export default __webpack_public_path__ + "static/media/como-cadastrar-pagina1.2c7b168f.svg";